// extracted by mini-css-extract-plugin
module.exports = {"b128or5g":"b128or5g"};